import style from "./styles.module.scss"

import { TextWithIcon } from "ui-kit/components-branded/Text/TextWithIcon"
import { Icon } from "components"

interface Props {
    onClick?: () => void | Element
}

export function BackButton({ onClick }: Props) {
    return (
        <TextWithIcon
            className={style.backText}
            icon={<Icon type="chevron-left-small" className={style.iconBack} size={24} />}
            position="left"
            onClick={onClick}
        >
            Назад
        </TextWithIcon>
    )
}
